module.exports = __webpack_public_path__ + "static/media/ritsu_defaultdb98329e53f5cf2d0ba0715e92a3be0c.webp";